async function trackAnonymousPageView(slug, utm) {
  if (!slug) return;

  const payload = {
    eventName: 'pageView',
    ...(utm ? { utm } : {}),
  };

  try {
    await fetch(`/api/v1/${encodeURIComponent(slug)}/tracking`, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    // Tracking must never affect checkout behavior.
  }
}

export default trackAnonymousPageView;
